import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';


@Injectable({
  providedIn: 'root'
})
export class AuthguardGuard implements CanActivate {

  currentUser:any;
  constructor(public config: ConfigService, private router: Router) {
    this.currentUser = localStorage.getItem('access_token');
  }


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {

    this.currentUser = localStorage.getItem('access_token');

    if(this.currentUser){
      return true;
    } else{
      this.router.navigate(['/login']);
      return false;
    }


  }

}


